import React from 'react';
import { Icon, Tooltip } from 'antd';
import colors from 'constants/colors';

type TemplateStatisticProps = {
  type: 'error' | 'warning',
  count: number,
};

export default function TemplateStatistic(props: TemplateStatisticProps) {
  const { type = 'error', count = 0 } = props;
  const color = type === 'error' ? colors.ERROR : colors.WARNING;
  return (
    <Tooltip title={`${count} ${type}s found`}>
      <div className="flex" style={{ alignItems: 'center' }}>
        <Icon
          style={{ color, fontSize: 16 }}
          theme="filled"
          type={type === 'error' ? 'info-circle' : 'warning'}
        />
        <p style={{ marginLeft: 3, color, marginBottom: -2 }}>{count}</p>
      </div>
    </Tooltip>
  );
}
